import React, { Component } from 'react';
import { Row, Col, Grid, Button } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import DateTimePicker from 'react-widgets/lib/DateTimePicker';
import { printCode } from '../../../actions/purchaseOrders_actions';
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';

class PrintBarcodeModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [{ date: new Date(), wt: 0 }],
    };
  }

  handleAdd = () => {
    let list = [...this.state.list];
    list.push({ date: new Date(), wt: 0 });
    this.setState({ list });
  }

  handleClear = () => {
    this.setState({
      list: [{ date: new Date(), wt: 0 }],
    })
  };

  handleDebouncePrint = _.debounce(() => {
    let data = [];
    this.state.list.map(dat => {
      if (Number(dat.wt) > 0) {
        data.push({
          prod_wt: Number(dat.wt),
          prod_num: this.props.ProductNum,
          pack_time: moment(dat.date).format('YYYY-MM-DD'),
          prod_ref: this.props.ProductRef,
        });
      }
    })
    if (data.length == 0) {
      alert('Please enter weight');
      return
    }
    this.props.printCode(data);
  }, 300);

  handleChangeDate = (date, ind) => {
    let list = this.state.list.map((dat, index) => {
      if (index === ind) {
        return { ...dat, date };
      }
      return { ...dat };
    })
    this.setState({ list })
  }

  handleChangeWt = (wt, ind) => {
    let list = this.state.list.map((dat, index) => {
      if (index === ind) {
        return { ...dat, wt };
      }
      return { ...dat };
    })
    this.setState({ list })
  }

  handleDelete = (ind) => {
    let list = [];
    this.state.list.map((dat, index) => {
      if (index != ind) {
        list.push({ ...dat });
      }
    })
    this.setState({ list })
  }

  renderDate = (date, index) => {
    return <DateTimePicker
      placeholder={'YYYY-MM-DD'}
      format="YYYY-MM-DD"
      className={'test-rw-input'}
      time={false}
      date={true}
      dropUp={false}
      onChange={(date) => {
        this.handleChangeDate(date, index);
      }}
      value={date}
      defaultValue={undefined}
    />
  }

  renderWt = (wt, index) => {
    return <div style={{ display: 'flex', flexDirection: 'row', }}>
      <div style={{ fontWeight: 'bold', marginRight: '4px' }}>
        <Translate value='wt' />
      </div>
      <input
        style={{ border: 'solid', borderWidth: '1px', width: '100px', paddingLeft: '4px' }}
        value={wt}
        onChange={(e) => {
          this.handleChangeWt(e.target.value, index);
        }}
      />
    </div>
  }

  renderDateAndWt = () => {
    return <div style={{ display: 'flex', flexDirection: 'column', overflowY: 'auto', width: '430px', height: '400px' }}>
      {this.state.list.map((code, index) => {
        return <div key={index} style={{ display: 'block', alignItems: 'center', marginTop: '10px' }}>
          <Row>
            <Col xs={2}>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <Button
                  bsStyle="danger"
                  onClick={() => {
                    this.handleDelete(index);
                  }}>
                  x
                </Button>
                <div style={{ marginLeft: '6px' }}>
                  {index + 1}
                </div>
              </div>
            </Col>
            <Col xs={6}>
              {this.renderDate(code.date, index)}
            </Col>
            <Col xs={4}>
              {this.renderWt(code.wt, index)}
            </Col>
          </Row>
        </div>
      })}
    </div>
  }

  render() {
    return (
      <Grid>
        <div style={{ display: 'flex', flexDirection: 'row', width: '430px', alignItems: 'center' }}>
          <Button
            disabled={this.state.list.length >= 50}
            className='btn btn-primary'
            onClick={this.handleAdd}>
            <em className='fa fa-plus' />
          </Button>
          <Button
            style={{ marginLeft: '20px' }}
            bsStyle="danger"
            onClick={this.handleClear}>
            <Translate value='clear' />
          </Button>
        </div>
        {this.renderDateAndWt()}
        <div style={{ display: 'flex', marginTop: '20px', flexDirection: 'row', justifyContent: 'center', width: '430px' }}>
          <Button bsStyle="danger"
            onClick={() => {
              this.props.close();
            }}>
            <Translate value='cancel' />
          </Button>
          <Button className='btn btn-primary'
            style={{ marginLeft: '60px' }}
            onClick={this.handleDebouncePrint}>
            <Translate value='print' />
          </Button>
        </div>
      </Grid>
    )
  }
}

const mapDispatchToProps = {
  printCode,
}
export default connect(null, mapDispatchToProps)(PrintBarcodeModal);



// WEBPACK FOOTER //
// ./master/jsx/components/Products/components/PrintBarcodeModal.jsx